<template>
    <div>
        <navs></navs>
        <div class="banner">
            <banner :img="bannerImg" titleEn="Contact us" titleCn="联系方式"></banner>
        </div>
        <div class="contact_box">
            <div class="all_box">
                <div class="contact_list">
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-平湖分公司
                        </div>
                        <div class="item_phone">
                            0573-85083375
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-北京分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-天津分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-上海分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-广州分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-杭州分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-济南分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-南京分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-合肥分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-厦门分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-南昌分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-郑州分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-武汉分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-长沙分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-成都分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-西安分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                    <div class="contact_item">
                        <div class="item_title">
                            浙江橙兰外包服务有限公司-兰州分公司
                        </div>
                        <div class="item_phone">
                            0573-87763210
                        </div>
                        <div class=item_add>
                            浙江海宁经编产业园区经都二路8号宝君国际303室
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <friend></friend>
        <foots  @navChange="initDw"></foots>
    </div>
</template>
<script>
    import friend from '@/components/friend.vue'
    import banner from '@/components/banner.vue'
    import navs from '@/components/navs.vue'
    import foots from '@/components/foots.vue'
    import bannerImg from '@/assets/img/contact_banner.png'
    export default {
        name: 'Contact',
        data() {
            return {
                bannerImg: bannerImg
            }
        },
        mounted() {
            this.initDw()
        },
        methods: {
            initDw(){
                window.scrollTo(0,0);
            },
        },
        components: {
            navs,
            foots,
            banner,
            friend
        }
    }
</script>
<style lang="scss" scoped>
    .contact_box {
        padding: 80px 0 144px;
    }

    .contact_list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .contact_item {
            position: relative;
            width: 30%;
            border: 1px solid rgba(0, 0, 0, .1);
            margin: 25px 0;
            padding: 35px 43px 20px;
            box-sizing: border-box;
            color: #BABABA;

            .item_title {
                font-size: 20px;
                font-weight: 700;
                margin-bottom: 11px;
            }

            .item_phone {
                font-size: 20px;
                font-weight: 700;
                margin-bottom: 18px;
            }

            .item_add {
                font-size: 16px;
                font-weight: 400;
            }
        }

        .contact_item:after {
            content: '';
            width: 100%;
            height: 0px;
            background: #f08300;
            position: absolute;
            left: 0;
            top: 0;
        }

        .contact_item:hover:after {
            height: 2px;
        }

        .contact_item:hover {

            .item_title {
                color: #333;
            }

            .item_phone {
                color: #333;
            }

            .item_add {
                color: #333;
            }
        }
    }
</style>